import React from "react";
import { unixFormat } from "../../../../helpers/times";
import ScheduleEpisodeStatus from "../../../Schedule/ScheduleComponents/ScheduleEpisodeStatus";
import { getEpisodeStatus } from "../../../../helpers/schedule-helper";
import { EPISODE_STATUSES } from "../../../../constants/common";
import "./styles.scss";

const OptionEpisode = ({value, onChange}) => {
    const isLive = getEpisodeStatus({timeStart: value.timeStart, timeStop: value.timeStop}) === EPISODE_STATUSES.live;
    const className = "option-episode";

    if (value.value === null) {
        return (
            <div className={`${className} option-cancel`} onClick={() => onChange(null)}>
                {value.label}
            </div>
        )
    }

    return (
        <div className={`${className} ${isLive ? '-live' : ''}`} onClick={() => onChange(value.id)}>
            <div className={`${className}--header`}>
                <div className={`${className}--time`}>
                    {unixFormat(value.timeStart, 'HH:mm')} — {unixFormat(value.timeStop, 'HH:mm')}
                </div>
                <ScheduleEpisodeStatus
                    timeStart={value.timeStart}
                    timeStop={value.timeStop}
                />
            </div>
            <div className={`${className}--body`}>
                <div className={`${className}--label`}>
                    {value.label}
                </div>
            </div>
        </div>
    );
}

export default OptionEpisode;
